import { coreInitiativesFilesGetAsyncSlice } from './get';
import { CoreInitiativesFilesName } from './name';
import { createAddCollectionSyncSlice } from '@sonar-software/xuder';
import { InitiativeFile } from '@types';

export const coreInitiativesFilesAddSyncSlice = createAddCollectionSyncSlice({
	add: (file: InitiativeFile) => file,
	hasRequest: true,
	name: CoreInitiativesFilesName,
	state: coreInitiativesFilesGetAsyncSlice.asyncState
});
